module.exports = __webpack_public_path__ + "img/workshop_einschaetzung.c1881be0.png";